import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom"; // , useLocation
import Sidebar from "./components/Sidebar";
import "./App.css";

import InvitationPage from "./pages/InvitationPage";
// import LoginPage from "./pages/LoginPage";
import InfosPratiques from "./pages/InfosPratiques";
import Activites from "./pages/Activites";
import Contribution from "./pages/Contribution";
import Playlist from "./pages/Playlist";
import Photos from "./pages/Photos";
import FAQ from "./pages/FAQ";
import Civil from "./pages/Civil";
import MenuBar from "./pages/MenuBar";
import Boutchou from "./pages/Boutchou";
import Urne from "./pages/Urne";
import Nina from "./pages/Nina";
import Galerie from "./pages/Galerie";
import Upload from "./pages/Upload";

function Layout() {
  // const location = useLocation();
  const hideSidebar = false; /*location.pathname === "/";*/
  const [menuOpen, setMenuOpen] = useState(false);

  return (

    <div className={`layout ${menuOpen ? "menu-open" : ""}` }>
      {!hideSidebar && (
        <>
          <Sidebar isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
        </>
      )}

 {/* <div style={{ display: "flex" }}>
   {!hideSidebar && <Sidebar />} */}

        <div className={`content ${hideSidebar ? "no-sidebar" : "with-sidebar"}`}>
          <Routes>
            {/* <Route path="/" element={<LoginPage />} /> */}
            <Route path="/" element={<Civil />} />
            <Route path="/invitation" element={<InvitationPage />} />
            <Route path="/menu-bar" element={<MenuBar />} />
            <Route path="/infos" element={<InfosPratiques />} />
            <Route path="/activites" element={<Activites />} />
            <Route path="/boutchou" element={<Boutchou />} />
            <Route path="/contribution" element={<Contribution />} />
            <Route path="/playlist" element={<Playlist />} />
            <Route path="/photos" element={<Photos />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/civil" element={<Civil />} />
            <Route path="/urne" element={<Urne />} />
            <Route path="/nina" element={<Nina />} />
            <Route path="/galerie" element={<Galerie />} />
            <Route path="/upload" element={<Upload />} />
          </Routes>
        </div>

      </div >
      );

}

      function App() {
  return (
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
      )
}

      export default App;
